import axiosInstance from "../helpers/axiosInstance";

export const getAllUnitsApi = async () => {
    const url = `public/dropdown/units`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const addUnitApi = async (request) => {
    const url = `admin/units`;
    const response = await axiosInstance.post(url, request);
    return response.data;
};

export const updateUnitApi = async (request) => {
    const url = `admin/units`;
    const response = await axiosInstance.put(url, request);
    return response.data;
};
